module.exports = __webpack_public_path__ + "static/media/content-mk-illustr.e0882fa2.png";